/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryHook} from '../types'
import {getMerchantTotalLocalCashRedeemed} from '../api'

 export const useQueryGetMerchantTotalLocalCashRedeemed = createReactQueryHook('getMerchantTotalLocalCashRedeemed', getMerchantTotalLocalCashRedeemed)
